var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import TextSkeleton from "../../../Skeleton/TextSkeleton";
var PaginationSummary = function (_a) {
    var summaryFormatter = _a.summaryFormatter, page = _a.page;
    if (page) {
        return (_jsx("div", { children: _jsx("p", __assign({ className: "text-sm text-gray-700" }, { children: summaryFormatter(page.pageable.offset + 1, page.pageable.offset + page.numberOfElements, page.totalElements) })) }));
    }
    return (_jsx("div", __assign({ className: "w-[50px]" }, { children: _jsx(TextSkeleton, { width: "max-w-[50px]", height: "h-2" }) })));
};
export default PaginationSummary;
